import * as React from 'react';
import AppBar from './AppBar';
import t1Png from '../images/t1.png';
import t2Png from '../images/t2.png';
import t3Png from '../images/t3.png';
import t4Png from '../images/t4.png';
import { Link } from 'react-router-dom';

const tutorial = () => {
  const styleMarginBottom = {
    marginBottom: '50px'
  };
  const contents = [
    {
      image: t1Png,
      title: '1. Google Calendarの準備',
      content: [
        'Google Calendarに"【駅名】訪問先" のフォーマットで登録してください',
        '予定には開始時刻、集力時刻を入れてください。予定を終日にすると記録されません'
      ]
    },
    {
      image: t2Png,
      title: 'GET STARTED をクリック',
      content: []
    },
    {
      image: t3Png,
      title: 'APIアクセスを許可',
      content: [
        '利用したいGoogle Accountでログイン',
        'APIへのアクセス許可をしてください'
      ]
    },
    {
      image: t4Png,
      title: '移動履歴と経費精算用のためのCSVダウンロード',
      content: [
        '1. 移動経路を確認してください。必要に応じて、時刻、駅、訪問先の修正が可能です',
        '2-1. 移動経路を元に Yahoo 経路検索で検索した結果の "経路" と "金額" が出力されます',
        '2-2. 移動経路は "時間指定なし", "最短" で検索しています',
        '2-3. 経路リンクはクリックすると 実際にYahoo検索した結果が別タブで開きます',
        '3-1. 徒歩での移動だった場合など、不要な経路が出ている場合は "Delete" で削除が可能です',
        '3-2. 駅を変更した場合は "Recalc" 金額の再計算を行います',
        '4. カレンダーに登録していない経路を追加したい場合は "add New Transits" で新しい移動経路を作成可能です',
        '5. "CSV Download" ボタンで経費精算用の CSVがダウンロード可能です',
        '6. 当月以外の経費精算を行いたい場合は "Previos" "Next" で 次の移動が可能です'
      ]
    }
  ];
  return (
    <section className="hero s-medium is-primary is-bold">
      <div className="hero-head">
        <AppBar path="/tutorial" />
      </div>
      <div className="hero-body">
        <div className="container">
          <section style={styleMarginBottom} />
          {contents.map(item => {
            return (
              <section key={item.image}>
                <h2 className="title is-4">{item.title}</h2>
                <div className="content">
                  <ul>
                    {item.content.map((c, index) => (
                      <li key={index}>{c}</li>
                    ))}
                  </ul>
                </div>
                <div className="box">
                  <figure className="image is-2by1">
                    <img src={item.image} alt={item.title} />
                  </figure>
                </div>
                <h2 />
              </section>
            );
          })}
          <section style={styleMarginBottom} />
          <div>
            <Link className="button is-large is-link is-fullwidth" to="/">
              はじめる
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default tutorial;



// WEBPACK FOOTER //
// ./src/components/Tutorial.tsx